import Microgame from '../engine/Microgame.js';

export default class SafeCrackGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Coffre-fort !`, en: `Safe Crack!`, es: `¡Caja Fuerte!` },
            controls: { fr: `Tourne le cadran (ou clique gauche/droite) jusqu'au bon chiffre`, en: `Turn the dial (or click left/right) to the correct number`, es: `Gira el dial (o haz clic izquierda/derecha) hasta el número correcto` },
            objective: { fr: `Trouve la combinaison secrète en écoutant les clics`, en: `Find the secret combination by listening to the clicks`, es: `Encuentra la combinación secreta escuchando los clics` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg>`,
            actions: [
                { type: 'wait', duration: 820 },
                { type: 'tap', x: 50, y: 50, duration: 150 },
                { type: 'wait', duration: 360 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.dial = null;
        this.indicator = null;
        this.angle = 0;
        this.speed = 200;
        this.targetAngle = 0;

        // Difficulty scaling
        const speedMult = engine.speedMultiplier || 1.0;

        // Tolerance: starts at 18° at x1, shrinks gently to 10° at x4
        this.tolerance = 18 - (speedMult - 1) * (8 / 3);

        // Softened speed multiplier: map 1->4 to 1->2.8
        this.effectiveMult = 1.0 + (speedMult - 1) * (1.8 / 3);

        // Generous duration with soft curve
        const adjustedSpeed = 1 + (speedMult - 1) * (1.2 / 3);
        this.duration = 4200 * (speedMult / adjustedSpeed);
    }

    setup() {
        this.engine.ui.instruction.textContent = "CRACK!";

        // Constant Speed Logic:
        // We ensure the lock passes the target at least TWICE within the duration.
        const durationSec = this.duration / 1000;
        this.baseSpeed = (360 * 2.2) / durationSec;

        // Safe Body
        const safe = document.createElement('div');
        safe.style.position = 'absolute';
        safe.style.width = '200px';
        safe.style.height = '200px';
        safe.style.border = `4px solid ${this.secondaryColor}`;
        safe.style.borderRadius = '20px';
        safe.style.top = '50%';
        safe.style.left = '50%';
        safe.style.transform = 'translate(-50%, -50%)';
        this.container.appendChild(safe);

        // Dial (Rotates)
        this.dial = document.createElement('div');
        this.dial.style.position = 'absolute';
        this.dial.style.width = '120px';
        this.dial.style.height = '120px';
        this.dial.style.border = `8px solid ${this.primaryColor}`;
        this.dial.style.borderRadius = '50%';
        this.dial.style.top = '50%';
        this.dial.style.left = '50%';
        this.dial.style.transform = 'translate(-50%, -50%) rotate(0deg)';
        safe.appendChild(this.dial);

        // Notch on Dial
        const notch = document.createElement('div');
        notch.style.position = 'absolute';
        notch.style.width = '10px';
        notch.style.height = '20px';
        notch.style.background = this.primaryColor;
        notch.style.top = '-10px';
        notch.style.left = '50%';
        notch.style.transform = 'translateX(-50%)';
        this.dial.appendChild(notch);

        // Target Zone (Static)
        this.targetAngle = this.isPlayback ? 90 : Math.random() * 360;

        const target = document.createElement('div');
        target.style.position = 'absolute';
        target.style.width = '140px';
        target.style.height = '140px';
        target.style.borderRadius = '50%';
        target.style.top = '50%';
        target.style.left = '50%';
        target.style.transform = `translate(-50%, -50%) rotate(${this.targetAngle}deg)`;
        target.style.pointerEvents = 'none';
        safe.appendChild(target);

        const zone = document.createElement('div');
        zone.style.position = 'absolute';
        zone.style.width = '20px';
        zone.style.height = '20px';
        zone.style.background = this.secondaryColor;
        zone.style.top = '-10px';
        zone.style.left = '50%';
        zone.style.transform = 'translateX(-50%)';
        zone.style.boxShadow = `0 0 10px ${this.secondaryColor}`;
        target.appendChild(zone);

        this.onDown = this.onDown.bind(this);
        this.engine.input.element.addEventListener('pointerdown', this.onDown);
    }

    update(dt) {
        if (!this.active || this.won) return;

        // Softened speed: base speed * gentle multiplier
        let currentSpeed = this.baseSpeed * this.effectiveMult;

        this.angle += currentSpeed * (dt / 1000);
        this.dial.style.transform = `translate(-50%, -50%) rotate(${this.angle}deg)`;
    }

    onDown() {
        if (!this.active || this.won) return;

        // Normalize angles
        let current = this.angle % 360;
        if (current < 0) current += 360;

        let target = this.targetAngle % 360;

        // Diff
        let diff = Math.abs(current - target);
        if (diff > 180) diff = 360 - diff;

        if (diff <= this.tolerance) {
            this.win();
            this.dial.style.background = this.primaryColor;
            this.dial.style.boxShadow = `0 0 30px ${this.primaryColor}`;
        } else {
            this.lose();
        }
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onDown);
    }
}
